import type { ReactNode } from 'react';
import { Box } from '@mui/material';

const cols = (n: number) => `repeat(${n}, minmax(0, 1fr))`;

/** A row of StatTiles: two across on a phone, `lg` across on a laptop, `xl` across on a big screen */
export function TileGrid({ lg = 4, xl, children }: { lg?: number; xl?: number; children: ReactNode }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: { xs: 1.25, md: 2 },
        gridTemplateColumns: { xs: cols(2), lg: cols(lg), ...(xl ? { xl: cols(xl) } : {}) },
      }}
    >
      {children}
    </Box>
  );
}
